import { z } from 'src/lib'
import { OperacionLCSLHPTIFields, OperacionLCSLHPTITablaValorFields } from './fields'
import { schemaEntityWithId } from 'src/types'

export const schemaFormOperacionLCSLHPTITablaValor = z.object({
    [OperacionLCSLHPTITablaValorFields.CodInstrumento]: z.number(),
    [OperacionLCSLHPTITablaValorFields.DescInstrumento]: z.string(),
    [OperacionLCSLHPTITablaValorFields.CodOperacionTipo]: z.number(),
    [OperacionLCSLHPTITablaValorFields.DescOperacionTipo]: z.string(),
    
    [OperacionLCSLHPTITablaValorFields.Valor]: z
        .string({
            invalid_type_error: 'El valor es requerido',
            required_error: 'El valor es requerido'
        })
        .nullable()
        .refine(val => val !== null && val !== '', {
            message: 'El valor es requerido'
        }),
    [OperacionLCSLHPTITablaValorFields.Orden]: z.number(),
});

export type FormOperacionLCSLHPTITablaValor = z.infer<typeof schemaFormOperacionLCSLHPTITablaValor>;

const baseSchemaFormOperacionLCSLHPTI = z.object({
    [OperacionLCSLHPTIFields.CodPais]: z.number({ required_error: 'El país es requerido.' }),
    [OperacionLCSLHPTIFields.CodUnidadNegocio]: z.number({ required_error: 'La unidad de negocio es requerida.' }),
    // [OperacionLCSLHPTIFields.CodSectorComercial]: z.coerce.number({ invalid_type_error: 'El sector comercial es requerido.' }).min(1, { message: 'El sector comercial es requerido.' }),
    [OperacionLCSLHPTIFields.FechaSolicitud]: z.date({ required_error: 'La fecha de solicitud es requerida.' }),
    [OperacionLCSLHPTIFields.FechaVencimiento]: z.date({ required_error: 'La fecha de vencimiento es requerida.' }),
    [OperacionLCSLHPTIFields.Observaciones]: z.string().optional().nullable(),
    [OperacionLCSLHPTIFields.TablaValores]: z.array(schemaFormOperacionLCSLHPTITablaValor)
        .min(1, { message: 'Debe completar los valores de la tabla.' }),
});

export const schemaFormOperacionLCSLHPTI = baseSchemaFormOperacionLCSLHPTI
    .refine(
        (schema) => {
            if (schema.fechaVencimiento && schema.fechaSolicitud) {

                return schema.fechaVencimiento.getTime() >= schema.fechaSolicitud.getTime();
            }

            return true;
        },
        {
            message: 'La fecha de vencimiento debe ser mayor o igual a la fecha de solicitud.',
            path: [OperacionLCSLHPTIFields.FechaVencimiento],
        }
    );

export type FormOperacionLCSLHPTI = z.infer<typeof schemaFormOperacionLCSLHPTI>

export const schemaOperacionLCSLHPTI = z
    .object({
        [OperacionLCSLHPTIFields.CodOperacionLCSLHPTI]: z.number(),
        [OperacionLCSLHPTIFields.CodPais]: z.number(),
        [OperacionLCSLHPTIFields.NombrePais]: z.string(),
        [OperacionLCSLHPTIFields.CodUnidadNegocio]: z.number().nullable(),
        [OperacionLCSLHPTIFields.DescUnidadNegocio]: z.string().nullable(),
        [OperacionLCSLHPTIFields.CodSectorComercial]: z.number(),
        [OperacionLCSLHPTIFields.DescSectorComercial]: z.string(),
        [OperacionLCSLHPTIFields.FechaSolicitud]: z.coerce.date(),
        [OperacionLCSLHPTIFields.FechaVencimiento]: z.coerce.date(),
        [OperacionLCSLHPTIFields.CodEstado]: z.number(),
        [OperacionLCSLHPTIFields.DescEstado]: z.string(),
        [OperacionLCSLHPTIFields.FechaAprobacion]: z.coerce.date().nullable(),
        [OperacionLCSLHPTIFields.FechaAlta]: z.coerce.date().nullable(),
        [OperacionLCSLHPTIFields.IdUsuarioAlta]: z.number(),
        [OperacionLCSLHPTIFields.NombreUsuarioAlta]: z.string(),
        [OperacionLCSLHPTIFields.ApellidoUsuarioAlta]: z.string(),
        [OperacionLCSLHPTIFields.Observaciones]: z.string().nullable(),
        [OperacionLCSLHPTIFields.EstadoFinalizado]: z.boolean(),
        [OperacionLCSLHPTIFields.PermiteEditarOperacion]: z.boolean(),
        [OperacionLCSLHPTIFields.PermiteEliminarOperacion]: z.boolean(),
    })
    .merge(schemaEntityWithId)

export type OperacionLCSLHPTI = z.infer<typeof schemaOperacionLCSLHPTI>